import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ message, onConfirm, onCancel }) => {
  if (!message) return null;

  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-icon">
          ?
        </div>
        <div className="confirm-message">
          {message}
        </div>
        <div className="confirm-buttons">
          <button className="confirm-btn cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button className="confirm-btn confirm" onClick={onConfirm}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
